/**
 * SO TARTE 商品ページ 複数フレーバー選択・予約フォーム
 * assets/tarte-product-select-form.js
 *
 * STEP1: フレーバー（product.variants）
 * STEP2: OPTION（「Option」タグの付いた商品。liquid側で collections[options_collection] から描画）
 */

/**
 * ★ BOXサイズ料金（8cmミニタルトのみ適用）
 * 小BOX: 1〜2個 ¥110 / 大BOX: 3〜9個 ¥250
 * 10個超は大BOXを積み重ね、端数は小BOXでカバー
 */
const ST_BOX = {
  enabled:        window.STP_DATA && window.STP_DATA.enableBoxFee || false,
  smallVariantId: (window.STP_DATA && window.STP_DATA.boxSmallVariantId) || null,
  largeVariantId: (window.STP_DATA && window.STP_DATA.boxLargeVariantId) || null,
  smallPrice:     11000,  // ¥110
  largePrice:     25000,  // ¥250
  smallMax:       2,
  largeMax:       9,
};

/**
 * ★ 保冷オプション（variant IDのみ編集してください）
 */
const ST_COLD = {
  variantId:    null,   // ← 保冷オプションのvariant ID
  pricePerUnit: 1000,   // 30分単位 ¥10 = 1000 cents
  label:        '保冷オプション',
};

(function () {
  'use strict';

  const state = {
    selected:      {},     // STEP1 フレーバー { variantId: qty }
    optSelected:   {},     // STEP2 オプション商品 { variantId: qty }
    walkMin:       30,
    coldEnabled:   false,
    optNote:       '',
  };

  function fmt(cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  }

  function totalFlavorQty() {
    return Object.values(state.selected).reduce((sum, q) => sum + q, 0);
  }
  function totalOptQty() {
    return Object.values(state.optSelected).reduce((sum, q) => sum + q, 0);
  }

  // ── STEP1: フレーバー数量ステッパー
  function changeQty(card, delta) {
    const id = card.dataset.variantId;
    const next = Math.max(0, (state.selected[id] || 0) + delta);
    if (next === 0) {
      delete state.selected[id];
      card.classList.remove('stp__card--active');
    } else {
      state.selected[id] = next;
      card.classList.add('stp__card--active');
    }
    renderCardQty(card, next);
    updateSummary();
  }

  // ── STEP2: オプション商品 数量ステッパー（単一バリエーション商品・ナンバーキャンドルのチップも共通で使用）
  function changeOptQty(card, delta) {
    const id = card.dataset.variantId;
    const next = Math.max(0, (state.optSelected[id] || 0) + delta);
    if (next === 0) {
      delete state.optSelected[id];
      card.classList.remove('stp__card--active');
      // チップ（ナンバーキャンドルの数字タグ）は0になったら要素ごと削除
      if (card.classList.contains('stp__card--chip')) {
        card.remove();
        updateSummary();
        return;
      }
    } else {
      state.optSelected[id] = next;
      card.classList.add('stp__card--active');
    }
    renderCardQty(card, next);
    updateSummary();
  }

  // ── STEP2: ナンバーキャンドル等：年齢を入力すると自動で桁ごとに分解してチップ表示
  function applyDigitNumber(input) {
    const block = input.closest('.stp__digit-block');
    const previewWrap = block.querySelector('.stp__digit-preview');
    const warningEl = block.querySelector('.stp__digit-warning');
    const variants = JSON.parse(block.dataset.variants || '[]');
    const baseName = block.dataset.baseName;
    const requiresNote = block.dataset.requiresNote === 'true';

    // 前回分をクリア（このブロックがカートに反映していたvariantを一旦全部消す）
    const prevIds = (block.dataset.activeIds || '').split(',').filter(Boolean);
    prevIds.forEach((id) => { delete state.optSelected[id]; });
    previewWrap.innerHTML = '';

    const value = input.value.trim();
    if (!value) {
      block.dataset.activeIds = '';
      if (warningEl) warningEl.style.display = 'none';
      updateSummary();
      return;
    }

    const digits = value.replace(/[^0-9]/g, '').split('');
    const tally = {};      // { variantId: count }
    const missing = [];    // 在庫にない数字

    digits.forEach((d) => {
      const v = variants.find((v) => v.label === d);
      if (v) {
        tally[v.id] = (tally[v.id] || 0) + 1;
      } else if (!missing.includes(d)) {
        missing.push(d);
      }
    });

    const newIds = [];
    Object.entries(tally).forEach(([id, count]) => {
      const v = variants.find((v) => String(v.id) === String(id));
      state.optSelected[id] = count;
      newIds.push(id);

      const chip = document.createElement('span');
      chip.className = 'stp__digit-preview-chip';
      chip.dataset.variantId = id;
      chip.dataset.name = `${baseName}（${v.label}）`;
      chip.dataset.price = v.price;
      if (requiresNote) chip.dataset.requiresNote = 'true';
      chip.textContent = count > 1 ? `${v.label} ×${count}` : v.label;
      previewWrap.appendChild(chip);
    });

    block.dataset.activeIds = newIds.join(',');

    if (warningEl) {
      if (missing.length) {
        warningEl.textContent = `「${missing.join('、')}」は現在ご用意がありません。恐れ入りますが別の年齢表記か、STEP2の下の「ご要望・メッセージ」欄でお知らせください。`;
        warningEl.style.display = 'block';
      } else {
        warningEl.style.display = 'none';
      }
    }

    updateSummary();
  }

  // ── フレーバー説明ポップアップ
  function openFlavorPopup(imgWrap) {
    const name  = imgWrap.dataset.flavorName || '';
    const desc  = imgWrap.dataset.desc || '';
    const imgEl = imgWrap.querySelector('img');
    const src   = imgEl ? imgEl.src : '';

    const modal    = document.getElementById('stp-flavor-modal');
    const modalImg = document.getElementById('stp-flavor-modal-img');
    const modalName = document.getElementById('stp-flavor-modal-name');
    const modalDesc = document.getElementById('stp-flavor-modal-desc');

    if (modalImg) { modalImg.src = src; modalImg.alt = name; }
    if (modalName) modalName.textContent = name;
    if (modalDesc) modalDesc.textContent = desc;
    if (modal) modal.classList.add('stp-flavor-modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeFlavorModal() {
    const modal = document.getElementById('stp-flavor-modal');
    if (modal) modal.classList.remove('stp-flavor-modal--open');
    document.body.style.overflow = '';
  }

  function renderCardQty(card, qty) {
    const qtyEl = card.querySelector('.stp__card-qty-num');
    if (qtyEl) qtyEl.textContent = qty;
  }

  function updateOptNote(value) {
    state.optNote = value;
    const errorEl = document.getElementById('stp-opt-note-error');
    if (errorEl && value.trim()) errorEl.style.display = 'none';
  }

  // ── 「ご要望・メッセージ」が必須かどうかチェック
  function noteIsRequired() {
    const optionGrid = document.getElementById('stp-option-grid');
    if (!optionGrid) return false;
    return optionGrid.querySelectorAll('.stp__card--active[data-requires-note="true"], .stp__digit-preview-chip[data-requires-note="true"]').length > 0;
  }

  // ── 対象オプション（トッパー・プレート・クッキープレート等）が選ばれている時だけ「ご要望・メッセージ」欄を表示
  function updateNoteVisibility() {
    const wrap = document.getElementById('stp-opt-note-wrap');
    if (!wrap) return;
    const show = noteIsRequired();
    wrap.style.display = show ? 'block' : 'none';
    if (!show) {
      const errorEl = document.getElementById('stp-opt-note-error');
      if (errorEl) errorEl.style.display = 'none';
    }
  }

  // ── 持ち歩き時間スライダー（60分まで無料、以降30分毎¥10）
  function updateWalk(value) {
    const min = parseInt(value, 10);
    state.walkMin = min;

    const valEl = document.getElementById('stp-walk-value');
    const feeEl = document.getElementById('stp-walk-fee');
    if (valEl) valEl.textContent = min;

    const fee = calcWalkFee(min);
    if (feeEl) feeEl.textContent = fee === 0 ? '無料' : fmt(fee);

    // 60分を超えたら保冷オプションを自動で有効にする（手動でOFFにすることも可能）
    const hintEl = document.getElementById('stp-cold-hint');
    if (min > 60 && !state.coldEnabled) {
      state.coldEnabled = true;
      const el = document.getElementById('stp-opt-cold');
      const checkEl = document.getElementById('stp-opt-cold-check');
      if (el) el.classList.add('stp__opt--active');
      if (checkEl) checkEl.textContent = '✓';
      if (hintEl) {
        hintEl.textContent = '60分を超える持ち歩きのため、保冷オプションを自動で追加しました。';
        hintEl.style.display = 'block';
      }
    } else if (hintEl) {
      hintEl.style.display = 'none';
    }

    updateSummary();
  }

  function calcWalkFee(min) {
    if (min <= 60) return 0;
    const extraUnits = Math.ceil((min - 60) / 30);
    return extraUnits * ST_COLD.pricePerUnit;
  }

  // ── 保冷オプション トグル
  function toggleOption(key) {
    if (key !== 'cold') return;
    state.coldEnabled = !state.coldEnabled;
    const el = document.getElementById('stp-opt-cold');
    const checkEl = document.getElementById('stp-opt-cold-check');
    if (el) el.classList.toggle('stp__opt--active', state.coldEnabled);
    if (checkEl) checkEl.textContent = state.coldEnabled ? '✓' : '';

    const hintEl = document.getElementById('stp-cold-hint');
    if (hintEl) hintEl.style.display = (state.walkMin > 60 && !state.coldEnabled) ? 'block' : 'none';

    updateSummary();
  }

  // ── BOX料金計算（8cmのみ）
  function calcBoxFee(totalQty) {
    if (!ST_BOX.enabled || totalQty === 0) return { cents: 0, small: 0, large: 0 };

    let remaining = totalQty;
    let large = 0;
    let small = 0;

    while (remaining > ST_BOX.smallMax) {
      const chunk = Math.min(remaining, ST_BOX.largeMax);
      large += 1;
      remaining -= chunk;
    }
    if (remaining > 0) small += 1;

    const cents = large * ST_BOX.largePrice + small * ST_BOX.smallPrice;
    return { cents, small, large };
  }

  // ── サマリー再計算・描画
  function updateSummary() {
    updateNoteVisibility();

    const chips = [];
    const barLabels = [];
    let totalCents = 0;

    // STEP1 フレーバー（18cm/24cmに分かれている場合は両方集計）
    const flavorGrid = document.getElementById('stp-flavor-grid');
    const flavorGrid24 = document.getElementById('stp-flavor-grid-24');
    const flavorCards = [
      ...(flavorGrid ? flavorGrid.querySelectorAll('.stp__card--active') : []),
      ...(flavorGrid24 ? flavorGrid24.querySelectorAll('.stp__card--active') : []),
    ];
    flavorCards.forEach((card) => {
      const id    = card.dataset.variantId;
      const name  = card.dataset.name;
      const price = parseInt(card.dataset.price, 10);
      const qty   = state.selected[id] || 0;
      if (qty === 0) return;
      const lineTotal = price * qty;
      totalCents += lineTotal;
      chips.push(`<span class="stp-summary__chip">
        ${name} ${qty > 1 ? 'x' + qty : ''}
        <span class="stp-summary__chip-price">${fmt(lineTotal)}</span>
      </span>`);
      barLabels.push(qty > 1 ? `${name}×${qty}` : name);
    });

    // STEP2 オプション商品（通常のステッパー＋ナンバーキャンドルのプレビューチップ）
    const optionGrid = document.getElementById('stp-option-grid');
    const optionCards = optionGrid
      ? [...optionGrid.querySelectorAll('.stp__card--active'), ...optionGrid.querySelectorAll('.stp__digit-preview-chip')]
      : [];
    optionCards.forEach((card) => {
      const id = card.dataset.variantId;
      const name  = card.dataset.name;
      const unitPrice = parseInt(card.dataset.price, 10);
      const freeQty = parseInt(card.dataset.freeQty || '0', 10);
      const qty   = state.optSelected[id] || 0;
      if (qty === 0) return;

      const billableQty = Math.max(0, qty - freeQty);
      const lineTotal = billableQty * unitPrice;
      totalCents += lineTotal;

      let label = `${name} ${qty > 1 ? 'x' + qty : ''}`;
      if (freeQty > 0) {
        label = qty <= freeQty
          ? `${name} ${qty}本（${freeQty}本まで無料）`
          : `${name} ${qty}本（無料${freeQty}本＋追加${billableQty}本）`;
      }

      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        ${label}
        <span class="stp-summary__chip-price">${lineTotal === 0 ? '無料' : fmt(lineTotal)}</span>
      </span>`);
      barLabels.push(qty > 1 ? `${name}×${qty}` : name);
    });

    // 持ち歩き・保冷
    if (state.coldEnabled) {
      const walkFee = calcWalkFee(state.walkMin);
      totalCents += walkFee;
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        ${ST_COLD.label}（${state.walkMin}分）
        <span class="stp-summary__chip-price">${walkFee === 0 ? '無料' : fmt(walkFee)}</span>
      </span>`);
      barLabels.push(ST_COLD.label);
    }

    // BOX料金
    const totalQty = totalFlavorQty();
    const box = calcBoxFee(totalQty);
    if (box.cents > 0) {
      totalCents += box.cents;
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        BOX代（小×${box.small} 大×${box.large}）
        <span class="stp-summary__chip-price">${fmt(box.cents)}</span>
      </span>`);
    }

    const listEl        = document.getElementById('stp-summary-list');
    const totalEl        = document.getElementById('stp-summary-total');
    const totalMobileEl  = document.getElementById('stp-summary-total-mobile');
    const barItemsEl      = document.getElementById('stp-fixed-bar-items');
    const countEl         = document.getElementById('stp-selected-count');
    const optCountEl      = document.getElementById('stp-opt-selected-count');
    const btnEls          = document.querySelectorAll('.stp__btn[data-add-to-cart]');

    if (listEl) {
      listEl.innerHTML = chips.length
        ? chips.join('')
        : '<span class="stp-summary__empty">フレーバーを選択してください</span>';
    }
    if (totalEl) totalEl.textContent = fmt(totalCents);
    if (totalMobileEl) totalMobileEl.textContent = fmt(totalCents);
    if (barItemsEl) barItemsEl.textContent = barLabels.length ? barLabels.join('、') : 'フレーバーを選択してください';
    if (countEl) countEl.textContent = totalQty + '点選択中';
    if (optCountEl) optCountEl.textContent = totalOptQty() + '点選択中';
    btnEls.forEach((btn) => { btn.disabled = totalQty === 0; });
  }

  // ── カートに追加
  async function addToCart() {
    const totalQty = totalFlavorQty();
    if (totalQty === 0) return;

    // クッキープレート・トッパー・メッセージプレートを選んでいる場合はメッセージ必須
    if (noteIsRequired() && !state.optNote.trim()) {
      const errorEl = document.getElementById('stp-opt-note-error');
      const noteEl = document.getElementById('stp-opt-note');
      if (errorEl) errorEl.style.display = 'block';
      if (noteEl) {
        noteEl.focus();
        noteEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const pickupDate = document.getElementById('stp-pickup-date')?.value || '';
    const pickupTime = document.getElementById('stp-pickup-time')?.value || '';
    const extraNoteLines = [];

    const items = [];

    // STEP1 フレーバー（受取情報・メッセージは商品行には付けず、後でカートの「注文メモ」にまとめる）
    Object.entries(state.selected).forEach(([id, qty]) => {
      if (qty <= 0) return;
      items.push({ id: Number(id), quantity: qty, properties: {} });
    });

    // STEP2 オプション商品（無料分がある場合は差し引いた本数だけカートに追加、内訳はitem固有のためpropertiesに残す）
    const optionGrid = document.getElementById('stp-option-grid');
    Object.entries(state.optSelected).forEach(([id, qty]) => {
      if (qty <= 0) return;
      const card = optionGrid ? optionGrid.querySelector(`[data-variant-id="${id}"]`) : null;
      const freeQty = card ? parseInt(card.dataset.freeQty || '0', 10) : 0;

      if (freeQty > 0) {
        const billableQty = Math.max(0, qty - freeQty);
        const itemProps = {
          '本数内訳': `合計${qty}本（無料${Math.min(qty, freeQty)}本＋追加${billableQty}本）`,
        };
        if (billableQty > 0) {
          items.push({ id: Number(id), quantity: billableQty, properties: itemProps });
        } else {
          extraNoteLines.push(`キャンドル（無料分のみ）: ${qty}本`);
        }
      } else {
        items.push({ id: Number(id), quantity: qty, properties: {} });
      }
    });

    // 保冷オプション
    if (state.coldEnabled && ST_COLD.variantId) {
      items.push({ id: ST_COLD.variantId, quantity: 1, properties: {} });
    }

    // BOX代
    const box = calcBoxFee(totalQty);
    if (box.small > 0 && ST_BOX.smallVariantId) {
      items.push({ id: ST_BOX.smallVariantId, quantity: box.small, properties: {} });
    }
    if (box.large > 0 && ST_BOX.largeVariantId) {
      items.push({ id: ST_BOX.largeVariantId, quantity: box.large, properties: {} });
    }

    const btnEls = document.querySelectorAll('.stp__btn[data-add-to-cart]');
    btnEls.forEach((btn) => { btn.disabled = true; btn.textContent = '追加中…'; });

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('cart add failed');

      // 持ち歩き時間・受取日時・ご要望メッセージは商品行には付けず、
      // カート全体の「注文メモ」(cart.note) にまとめて記録する
      const noteLines = [];
      if (pickupDate) noteLines.push(`受取日: ${pickupDate}`);
      if (pickupTime) noteLines.push(`受取時間: ${pickupTime}`);
      noteLines.push(`持ち歩き時間: ${state.walkMin}分`);
      if (state.optNote) noteLines.push(`ご要望・メッセージ: ${state.optNote}`);
      noteLines.push(...extraNoteLines);

      await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ note: noteLines.join('\n') }),
      });

      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      alert('カートへの追加に失敗しました。もう一度お試しください。');
      btnEls.forEach((btn) => { btn.disabled = false; btn.textContent = 'カートに入れる'; });
    }
  }

  // ── 受取可能日の初期値設定（2営業日後・12時締切・月/日休み）
  function setMinPickupDate() {
    const dateInput = document.getElementById('stp-pickup-date');
    if (!dateInput) return;

    const now = new Date();
    const cutoffPassed = now.getHours() >= 12;
    let daysToAdd = cutoffPassed ? 3 : 2;

    const min = new Date(now);
    let added = 0;
    while (added < daysToAdd) {
      min.setDate(min.getDate() + 1);
      const day = min.getDay();
      if (day !== 0 && day !== 1) added++;
    }

    const yyyy = min.getFullYear();
    const mm   = String(min.getMonth() + 1).padStart(2, '0');
    const dd   = String(min.getDate()).padStart(2, '0');
    dateInput.min   = `${yyyy}-${mm}-${dd}`;
    dateInput.value = `${yyyy}-${mm}-${dd}`;
  }

  document.addEventListener('DOMContentLoaded', () => {
    setMinPickupDate();
    updateSummary();

    // Shopifyテーマ側のtransform(ページ遷移アニメーション等)でposition:fixedが
    // 効かなくなるのを避けるため、固定バーをbody直下に移動する
    const fixedBar = document.querySelector('.stp-fixed-bar');
    if (fixedBar && fixedBar.parentElement !== document.body) {
      document.body.appendChild(fixedBar);
    }
  });

  window.STP = {
    changeQty,
    changeOptQty,
    applyDigitNumber,
    toggleOption,
    updateWalk,
    updateOptNote,
    updateSummary,
    addToCart,
    openFlavorPopup,
    closeFlavorModal,
  };
})();
